export class Member {
    id = 0;
    userId = 0;
    userEmail = '';
    roleName = '';
    roleId = 0;
    fullCompanyAccess = false;

    public deserialize(data: any): this {
        this.id = data.id ?? 0;
        this.userId = data.user_id ?? 0;
        this.userEmail = data.user_email ?? '';
        this.roleName = data.role_name ?? '';
        this.roleId = data.role_id ?? 0;
        this.fullCompanyAccess = data.full_company_access ?? false;
        return this;
    }

    serialize(): any {
        return {
            id: this.id,
            user_id: this.userId,
            user_email: this.userEmail,
            role_name: this.roleName,
            role_id: this.roleId,
            full_company_access: this.fullCompanyAccess,
        };
    }
}
